import {ContentSubmissionState} from '@/api/fetchers/campaignContentSubmission';

export const PHASE = {
  ALL: 'all',
  PENDING: 'pending',
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
  ARCHIVED: 'archived',
} as const;

export type Phase = (typeof PHASE)[keyof typeof PHASE];

export const ALL_STATES_FILTER = Object.values(PHASE).filter(
  (phase) => phase !== PHASE.ALL
) as ContentSubmissionState[];
